import { Card } from "antd";
import { Bar } from "react-chartjs-2";

export const RoomNightPickup = (props) => {
  const { roomNightChartData, monthYear } = props;
  return (
    <Card style={{ margin: "20px auto", textAlign: "center" }} bordered>
      <h2 style={{ marginBottom: "20px" }}>
        {monthYear} (MTD Room Night Picked Up)
      </h2>
      {roomNightChartData ? (
        <Bar
          data={roomNightChartData}
          options={{
            responsive: true,
            plugins: {
              legend: { display: false },
              tooltip: {
                callbacks: {
                  label: (context) => `Room Nights: ${context.raw}`,
                },
              },
              datalabels: {
                display: true,
                color: "black",
                font: { size: 12, weight: "bold" },
                anchor: "end",
                align: "end",
                formatter: (value) => (value > 0 ? value : ""),
              },
            },
            scales: {
              x: {
                title: { display: true, text: "Date" },
                ticks: {
                  callback: (value, index) => {
                    const date = roomNightChartData.labels[index];
                    return date.split("-")[2]; // Show just day of the month
                  },
                },
              },
              y: {
                title: { display: true, text: "Room Nights" },
                beginAtZero: true,
              },
            },
          }}
        />
      ) : (
        <p>Loading room night chart...</p>
      )}
    </Card>
  );
};
